import { each } from 'lodash';

export function arrayCombine(arrays) {
  var newObj = {};

  var n = 3;
  var arrayLengthAndWidth = Object.keys(arrays[0]).length;
  for (var i = 0; i < arrays.length; i++) {
    var array = arrays[i]
    const iOverN = Math.floor(i/n);
    const iModN = i % n
    each(array, (row, rowKey) => {
      each(row, (item, itemKey) => {
        var row = arrayLengthAndWidth*(iOverN) + (+rowKey);
        var cell = (iModN)*arrayLengthAndWidth + (+itemKey);
        newObj[row] = newObj[row] || {};
        newObj[row][cell] = item;
      })
    })
  }

  return newObj;
}

export function shadeColor(color, percent) {
  var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
  return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
}
